export default [
  {
    // Bản CTV không có trang Tổng quan/thống kê (backend đã bỏ `/dashboard/*`),
    // nên trang chủ đi thẳng vào danh sách đơn hàng. Giữ nguyên tên "default" vì
    // router guard và `redirectIfLoggedIn` đều điều hướng bằng tên này.
    path: "/",
    name: "default",
    meta: { title: "Đơn Hàng", authRequired: true },
    redirect: "/ecommerce/orders",
  },
  {
    path: "/demo/:orderCode",
    name: "demo-preview",
    component: () => import("@/views/demo/DemoPreviewPage.vue"),
    meta: { title: "Xem ảnh demo" },
  },

  // Ecommerce
  {
    path: "/ecommerce/customers",
    name: "customers",
    meta: { title: "Customers", authRequired: true },
    component: () => import("@/views/apps/ecommerce/customers"),
  },
  {
    path: "/ecommerce/customer-details/:id",
    name: "customer-detail",
    meta: { title: "Chi Tiết Khách Hàng", authRequired: true },
    component: () => import("@/views/apps/ecommerce/customer-details"),
  },
  {
    path: "/ecommerce/staff",
    name: "staff",
    meta: { title: "Staff", authRequired: true, requiresAdmin: true },
    component: () => import("@/views/apps/ecommerce/staff"),
  },
  {
    path: "/ecommerce/audit-logs",
    name: "audit-logs",
    meta: { title: "Nhật Ký Hoạt Động", authRequired: true, requiresAdmin: true },
    component: () => import("@/views/apps/ecommerce/audit-logs"),
  },
  {
    // Công nợ của chính CTV với xưởng — chỉ đọc, sổ gốc nằm ở CMS tổng.
    path: "/ecommerce/my-debt",
    name: "my-debt",
    meta: { title: "Công nợ với xưởng", authRequired: true },
    component: () => import("@/views/apps/ecommerce/my-debt"),
  },
  {
    path: "/ecommerce/products",
    name: "products",
    meta: { title: "Products", authRequired: true },
    component: () => import("@/views/apps/ecommerce/products"),
  },
  {
    path: "/ecommerce/product-details/:id",
    name: "product-detail",
    meta: { title: "Product Details", authRequired: true },
    component: () => import("@/views/apps/ecommerce/product-details"),
  },

  // Orders
  {
    path: "/ecommerce/orders",
    name: "orders",
    meta: { title: "Orders", authRequired: true },
    component: () => import("@/views/apps/ecommerce/order/orders"),
  },
  {
    path: "/ecommerce/order-notes",
    name: "order-notes",
    meta: { title: "Ghi chú đơn hàng", authRequired: true },
    component: () => import("@/views/apps/ecommerce/order/order-notes"),
  },
  {
    path: "/ecommerce/add-order",
    name: "add-order",
    meta: { title: "Tạo Đơn Hàng", authRequired: true },
    component: () => import("@/views/apps/ecommerce/order/OrderFormPage"),
  },
  {
    path: "/ecommerce/edit-order/:id",
    name: "edit-order",
    meta: { title: "Sửa Đơn Hàng", authRequired: true },
    component: () => import("@/views/apps/ecommerce/order/OrderFormPage"),
  },
  {
    path: "/ecommerce/order-details",
    redirect: "/ecommerce/orders",
  },
  {
    path: "/ecommerce/order-details/:id",
    name: "order-details",
    meta: { title: "Order Details", authRequired: true },
    component: () => import("@/views/apps/ecommerce/order/order-details"),
  },

  // Không còn route tạo/sửa sản phẩm: danh mục là bản sao từ CMS tổng, backend đã
  // xoá hẳn POST/DELETE /products và chỉ cho sửa đúng GIÁ BÁN — việc đó làm tại chỗ
  // trên bảng ở /ecommerce/products. Ai gõ tay đường cũ thì để 404 bắt, đừng dựng
  // lại một trang form chỉ sửa được mỗi ô giá.
  {
    path: "/ecommerce/settings",
    name: "ecommerce-settings",
    meta: { title: "Settings", authRequired: true, requiresAdmin: true },
    component: () => import("@/views/apps/ecommerce/checkout"),
  },
  {
    path: "/ecommerce/carriers",
    name: "carriers",
    meta: { title: "Đơn Vị Vận Chuyển", authRequired: true, requiresAdmin: true },
    component: () => import("@/views/apps/ecommerce/carriers"),
  },

  {
    path: "/ecommerce/order-message-templates",
    name: "order-message-templates",
    meta: { title: "Mẫu Tin Nhắn", authRequired: true, requiresAdmin: true },
    component: () => import("@/views/apps/ecommerce/order-message-templates"),
  },

  // Zalo
  {
    path: "/zalo/groups",
    name: "zalo-groups",
    meta: { title: "Zalo Groups", authRequired: true, requiresAdmin: true },
    component: () => import("@/views/apps/ecommerce/zalo-groups"),
  },
  {
    path: "/zalo/groups/:id",
    name: "zalo-group-detail",
    meta: { title: "Zalo Group Detail", authRequired: true, requiresAdmin: true },
    component: () => import("@/views/apps/ecommerce/zalo-group-detail"),
  },

  // Account
  {
    path: "/pages/profile-setting",
    name: "profile-setting",
    meta: { title: "Setting", authRequired: true },
    component: () => import("@/views/pages/profile/setting"),
  },
];
